<template>
  <div class="fill-height">
    <div class="floating-btn text-center">
      <v-btn @click="cancelSearch" color="red lighten-4" elevation="0" rounded type="primary" v-if="searching">
        <v-icon left>mdi-close</v-icon>
        Cancel search
      </v-btn>
    </div>

    <!-- Products List -->
    <template>
      <ProductListVerticalCards :items="items" @add="add($event)" v-if="layout === 'grid'"/>
      <ProductListHorizontalCards :items="items" v-if="layout === 'full'"/>
    </template>

    <!-- Empty state -->
    <div class="items fill-height overflow-hidden overflow-hidden pa-2 d-flex flex-column align-center justify-center"
         v-if="!items.length && !loading">
      <v-icon color="grey lighten-2" size="50">mdi-checkbox-blank-off-outline</v-icon>
      <div class="text-title mt-4 font-weight-light">No items</div>
    </div>
  </div>
</template>

<script>
import ProductListVerticalCards from "./ProductListVerticalCards";
import ProductListHorizontalCards from "./ProductListHorizontalCards";

export default {
  name: "ProductsList",
  components: { ProductListHorizontalCards, ProductListVerticalCards },
  props: {
    items: {
      type: Array,
      required: true
    },
    layout: {
      type: String,
      default: 'grid'
    }
  },
  data: () => ({
    selected: {},
    views: {
      add: false
    }
  }),
  methods: {
    add(item) {
      this.selected = item;
      this.views.add = true;
    },
    cancelSearch() {
      this.$store.commit('catalogue/cancelSearch')
    },
  },
  computed: {
    loading() {
      return this.$store.state.catalogue.loading;
    },
    searching() {
      return this.$store.state.catalogue.searching
    },
  },
}
</script>

<style lang="scss" scoped>
.floating-btn {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 100px;
  z-index: 1;
}
</style>
